import React from "react";
import { View, StyleSheet } from "react-native";
import { colors, radii, spacing } from "../../../styles/design-system";
import CustomText from "../../../components/common/general/CustomText/CustomText";

export type ExplanationCardProps = {
  explanation: string | null;
  visible?: boolean;
  containerStyle?: object;
  labelStyle?: object;
  textStyle?: object;
};

const ExplanationCard = ({
  explanation,
  visible = true,
  containerStyle,
  labelStyle,
  textStyle,
}: ExplanationCardProps) => {
  if (!visible || !explanation) return null;

  return (
    <View style={[styles.explanationContainer, containerStyle]}>
      <CustomText
        text="Explanation"
        size="xs"
        weight="bold"
        style={[styles.explanationLabel, labelStyle]}
        useTranslationText={false}
      />
      <CustomText text={explanation} size="s" style={[styles.explanationText, textStyle]} useTranslationText={false} />
    </View>
  );
};

const styles = StyleSheet.create({
  explanationContainer: {
    marginTop: spacing.xs,
    padding: 4,
    backgroundColor: colors.warning[25],
    borderRadius: radii.md,
    borderWidth: 1,
    borderColor: colors.warning[200],
    gap: spacing.xxs,
  },
  explanationLabel: {
    color: colors.warning[700],
  },
  explanationText: {
    color: colors.warning[800],
    lineHeight: 20,
  },
});

export default ExplanationCard;
